namespace advisorop.services {
    "use strict";

    export class OrionService {
        static $inject = ["$http"];

        constructor(private $http: ng.IHttpService) {
        }

        getTieredFeeSchedules(): ng.IHttpPromise<domains.IBillScheduleFullDto[]> {
            return this.$http.get("/api/orion/tieredfeeschedules");
        }

        getAccountByNumber(accountNumber: string): ng.IHttpPromise<domains.IAccountFeeModelDto> {
            return this.$http.get(`/api/orion/account/${encodeURIComponent(accountNumber)}`);
        }

    }
    angular.module(Constants.ADVOP_SERVICES).service("orionService", OrionService);
}
